const initialState = { doors: [], accessGroups: [] };

const authenticationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ACCESS": {
      const doors = [];
      action.data.map((a) => {
        a.access_level_items.map((b) => {
          b.doors.map((door) => {
            if (doors.find((d) => d.id === door.id)) {
              return;
            }
            doors.push(door);
          });
        });
      });

      return {
        ...state,
        accessGroups: [...action.data],
        doors,
      }
    };
    case "FETCH_ACCESS_V2":
      return {
        ...state,
        accessGroups: action.data.access_groups,
        doors: action.data.doors,
      };
    default:
      return state;
  }
};

export default authenticationReducer;
